<div>
  <section>
    <span>{{ time }}</span>
    <small>{{ date }}</small>
  </section>
</div>
